import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, Input, HostBinding, NgModule } from '@angular/core';
import * as i1 from 'se-fe-icon';
import { SeFeIconModule, seFeIconCheckCircle, seFeIconInfoCircle, seFeIconMinusCircle, seFeIconWarning } from 'se-fe-icon';

var SeFeBannerClassConst;
(function (SeFeBannerClassConst) {
    SeFeBannerClassConst["BASE_CLASS"] = "se-fe-banner--";
    SeFeBannerClassConst["INFO_CLASS"] = "info";
    SeFeBannerClassConst["SUCCESS_CLASS"] = "success";
    SeFeBannerClassConst["WARNING_CLASS"] = "warning";
    SeFeBannerClassConst["ERROR_CLASS"] = "error";
})(SeFeBannerClassConst || (SeFeBannerClassConst = {}));
var SeFeBannerType;
(function (SeFeBannerType) {
    SeFeBannerType["INFO"] = "info";
    SeFeBannerType["SUCCESS"] = "success";
    SeFeBannerType["WARNING"] = "warning";
    SeFeBannerType["ERROR"] = "error";
})(SeFeBannerType || (SeFeBannerType = {}));
var SeFeBannerIcon;
(function (SeFeBannerIcon) {
    SeFeBannerIcon["info"] = "info_circle";
    SeFeBannerIcon["success"] = "check_circle";
    SeFeBannerIcon["warning"] = "warning";
    SeFeBannerIcon["error"] = "minus_circle";
})(SeFeBannerIcon || (SeFeBannerIcon = {}));
var SeFeBannerIconColor;
(function (SeFeBannerIconColor) {
    SeFeBannerIconColor["info"] = "primary";
    SeFeBannerIconColor["success"] = "success";
    SeFeBannerIconColor["warning"] = "warn";
    SeFeBannerIconColor["error"] = "alert";
})(SeFeBannerIconColor || (SeFeBannerIconColor = {}));
class SeFeBannerComponent {
    constructor() {
        this.bannerTypeInput = SeFeBannerType.INFO;
        this.title = '';
        this.showIcon = false;
    }
    get classes() { return this.bannerClass; }
    ngOnInit() {
        this.bannerType = this.getBannerType(this.bannerTypeInput);
        this.iconType = SeFeBannerIcon[this.bannerType];
        this.iconColor = SeFeBannerIconColor[this.bannerType];
    }
    getBannerType(inputtedType) {
        return this.validateType(SeFeBannerType, inputtedType) ? inputtedType : SeFeBannerType.INFO;
    }
    validateType(object, value) {
        return Object.values(object).some((v) => v === value);
    }
    get bannerClass() {
        return `${SeFeBannerClassConst.BASE_CLASS}${this.bannerType}`;
    }
}
SeFeBannerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeBannerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeBannerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeBannerComponent, selector: "se-fe-banner", inputs: { bannerTypeInput: ["seFeDataType", "bannerTypeInput"], title: ["seFeDataTitle", "title"], showIcon: ["seFeShowIcon", "showIcon"] }, host: { properties: { "class": "this.classes" } }, ngImport: i0, template: "<div class=\"se-fe-banner\">\n  <div *ngIf=\"showIcon\" class=\"se-fe-banner__icon\">\n    <se-fe-icon\n      [seFeDataName]=\"iconType\"\n      seFeDataSize=\"600\"\n      [seFeDataColor]=\"iconColor\">\n    </se-fe-icon>\n  </div>\n  <div class=\"se-fe-banner__content\">\n    <div class=\"se-fe-banner__text\">\n      <div class=\"se-fe-banner__header\">\n        {{ title }}\n      </div>\n      <div class=\"se-fe-banner__subheader\">\n        <ng-content select=\"[seFeBannerSubtitle]\"></ng-content>\n      </div>\n    </div>\n  </div>\n  <div class=\"se-fe-banner__action\">\n    <ng-content select=\"[seFeBannerAction]\"></ng-content>\n  </div>\n</div>\n", styles: [":host{background:#fff;border-radius:4px;border:1px solid #e3e8eb;border-left-width:4px;color:#23282b;display:block;flex-direction:row;font-size:.8571428571rem;font-family:\"Open Sans\",sans-serif;opacity:1;padding:0 12px;position:relative}:host.se-fe-banner--info{border-left-color:#00668f}:host.se-fe-banner--success{border-left-color:#00a846}:host.se-fe-banner--warning{border-left-color:#f0b428}:host.se-fe-banner--error{border-left-color:#b42846}:host .se-fe-banner{display:flex;flex-wrap:wrap;margin:6px 0}:host .se-fe-banner__icon{flex:0 0 auto;margin-top:12px}:host .se-fe-banner__content{display:block;flex:100 1 0;justify-content:center;margin:6px 0;padding-left:8px}:host .se-fe-banner__content .se-fe-banner__header{font-size:1rem;font-weight:600;margin-bottom:4px}:host .se-fe-banner__content .se-fe-banner__subheader{color:#68767f;font-size:.8571428571rem}:host .se-fe-banner__action{display:block;flex:0 0 100%;justify-content:center;margin:6px 0;padding-left:8px}@media (min-width: 600px){:host .se-fe-banner__action{flex:0 0 auto}}\n"], components: [{ type: i1.SeFeIconComponent, selector: "se-fe-icon", inputs: ["seFeDataAriaLabel", "seFeDataMargin", "seFeDataSize", "seFeDataColor", "seFeDataName"] }], directives: [{ type: i2.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeBannerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-banner',
                    templateUrl: './se-fe-banner.component.html',
                    styleUrls: ['./se-fe-banner.component.scss'],
                }]
        }], propDecorators: { bannerTypeInput: [{
                type: Input,
                args: ['seFeDataType']
            }], title: [{
                type: Input,
                args: ['seFeDataTitle']
            }], showIcon: [{
                type: Input,
                args: ['seFeShowIcon']
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

class SeFeBannerModule {
}
SeFeBannerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeBannerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeBannerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeBannerModule, declarations: [SeFeBannerComponent], imports: [CommonModule, i1.SeFeIconModule], exports: [SeFeBannerComponent] });
SeFeBannerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeBannerModule, imports: [[
            CommonModule,
            SeFeIconModule.include([
                seFeIconCheckCircle,
                seFeIconInfoCircle,
                seFeIconMinusCircle,
                seFeIconWarning,
            ])
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeBannerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SeFeBannerComponent],
                    imports: [
                        CommonModule,
                        SeFeIconModule.include([
                            seFeIconCheckCircle,
                            seFeIconInfoCircle,
                            seFeIconMinusCircle,
                            seFeIconWarning,
                        ])
                    ],
                    exports: [SeFeBannerComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeBannerClassConst, SeFeBannerComponent, SeFeBannerIcon, SeFeBannerIconColor, SeFeBannerModule, SeFeBannerType };
